import { render, staticRenderFns } from "./StoriesArticleIllustratedMainCopyParagraph.vue?vue&type=template&id=208b8971&scoped=true&"
import script from "./StoriesArticleIllustratedMainCopyParagraph.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainCopyParagraph.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainCopyParagraph.vue?vue&type=style&index=0&id=208b8971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b8971",
  null
  
)

export default component.exports